
import React, { Component } from "react";
import { notification, message, Tabs, Spin } from 'antd';
import PanelIndSalud from "./PanelV1/PanelIndSalud";
import PanelGeneral from "./PanelGeneral/PanelGeneral";
import PanelPerfilEmb from "./PanelPerfilEmb/PanelPerfilEmb";
import PanelCensoEmb from "./PanelPerfilEmb/PanelCensoEmb";
import PanelPacCronicos from "./PanlePacCronicos/PanelPacCronicos";
import PanelPacCronicos2 from "./PanlePacCronicos/PanelPacCronicos2";
import PanelRecetas from "./PanelRecetas/PanelRecetas.js";

import styled from "styled-components";
import '../../src/App.css';

const { TabPane } = Tabs;

export const styleBorderShadow = {
  "border-radius":"10px",
  "box-shadow": "0px 0px 15px #e7ebf0"
  // "box-shadow": "0px 0px 15px #F5F5F5"
}

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav-scroll {
    text-align: center;
  }
  .ant-tabs-nav {
    text-align: center;
    font-size: 18px;
    font-weight: lighter;
    color: "#006297";
  }

  .ant-tabs-tab-active {
    background-color: "#B6884C";
    color: "#f5f5f5";
    border-radius: 6px;
  }
  .ant-tabs-ink-bar {
    background-color: transparent !important;
  }
`;

export default class PanelComponentNL extends Component {

  state = {
    environments: [],
    defaultTab: "1",
    unidad_medica_user: null,
    periodo: 2023,
    buscandoUnidad: false
  }

  onTabChange = (selectedTableIndex) => {
    this.setState({ defaultTab: selectedTableIndex, preventClick: true });
  };

  componentDidMount() {

    const { backend, user } = this.props;

    fetch(`${backend}/usuarioxunidad/${user}`,
    {
        method: "GET",
        headers: {
            'Access-Control-Allow-Origin': '*'
        }
    }).then((res) => {
        return res.json();
    }).then((data) => {
      
      if(data.data.length > 0){
        this.setState({
          unidad_medica_user: data.data,
          periodo: new Date().getFullYear(),
          buscandoUnidad:true
        })
      } else {
        this.setState({
          buscandoUnidad:true
        })
      }
    }).catch((error) => {
        console.log(error);
        notification.error({
            message: 'Error',
            description: "Ocurrió un error al obtener la unidad del usuario.",
        });
        message.destroy()
    });

  // }, 3000);
}

  render() {
    
    const { backend }  = this.props;
    const { unidad_medica_user, periodo, buscandoUnidad  } = this.state;
    
    return (
        buscandoUnidad ?
        unidad_medica_user !== null ?
            <StyledTabs 
              activeKey={this.state.defaultTab}
              defaultActiveKey={this.state.defaultTab}
              onChange={this.onTabChange}
            >
              {/* <TabPane tab="Estadisticas Personales" key="0">
                <PanelIndSalud unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane> */}
              <TabPane tab={"General " + periodo} key="1">
                <PanelGeneral unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane>
              <TabPane tab={"Perfil de embarazadas " + periodo} key="2">
                <PanelPerfilEmb unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane>
              <TabPane tab={"Censo   de embarazadas " + periodo} key="3">
                <PanelCensoEmb unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane>
              <TabPane tab={"Pacientes crónicos " + periodo + " A"} key="4">
                <PanelPacCronicos unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane>
              <TabPane tab={"Pacientes crónicos " + periodo + " B"} key="5">
                <PanelPacCronicos2 unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane>
              {/* <TabPane tab={"Recetas " + periodo} key="6">
                <PanelRecetas unidad_medica_user={unidad_medica_user[0].unidad_medica} periodo={periodo} backend={backend}/>
              </TabPane> */}
            </StyledTabs>
          :<div style={{ fontSize: "16px", padding:"1px" }}> 
            El usuario no tiene asignada una unidad médica. No se puede ver información.
          </div>
          :<div style={{ fontSize: "16px", padding:"1px" }}> 
            <Spin tip="Buscando unidad médica asignada al usuario."/>
          </div>    
    );
  }
}